import React, {useCallback, useEffect, useState} from "react";
import ajaxloader from "../../images/ajax-loader.gif";
import adminService from "../../services/admin.service";
import FundSubstitutionList from "./FundSubstitutionList";

export default function FundSubstitution(props) {

    const [loadStatus, setLoadStatus] = useState("idle");
    const [loadMessage, setLoadMessage] = useState("");

    const [subst, setSubst] = useState([]);

    const load = useCallback(() => {
        adminService.getFundSubstitutions().then(
            response => {
                setSubst(response.data["data"]);
                setLoadStatus("success");
            },
            error => {
                setLoadStatus("error");
                setLoadMessage("An error occurred while loading users");
            }
        );
    }, []);

    useEffect(() => {
        if (loadStatus === "idle") {
            setLoadStatus("pending");
            load();
        }
    }, [loadStatus, load]);

    if (loadStatus !== 'success') {
        return (
            <div className="main-content">
                <div style={{margin: "1rem auto"}}>
                    <img alt="loading" src={ajaxloader}/>
                </div>
            </div>
        )
    }

    if (!subst || subst.length === 0) {
        return (
            <div className="main-content">
                <div style={{margin: "1rem auto"}}>
                    <p>No data found</p>
                </div>
            </div>
        )
    }

    return (
        <div className="main-content">
            <FundSubstitutionList tgtDataOrig={subst}/>
        </div>
    );
}
